import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppFloat } from "@/components/layout/WhatsAppFloat";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import CoursesPage from "@/pages/CoursesPage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import ContactPage from "@/pages/ContactPage";
import AdminLeadsPage from "@/pages/AdminLeadsPage";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const trackingKeys = ["gclid", "fbclid", "mc_cid", "mc_eid"];
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    let hasTrackingParam = false;

    for (const key of Array.from(searchParams.keys())) {
      const normalizedKey = key.toLowerCase();
      if (normalizedKey.startsWith("utm_") || trackingKeys.includes(normalizedKey)) {
        searchParams.delete(key);
        hasTrackingParam = true;
      }
    }

    if (hasTrackingParam) {
      const nextSearch = searchParams.toString();
      const cleanUrl = `${url.pathname}${nextSearch ? `?${nextSearch}` : ""}${url.hash}`;
      window.history.replaceState({}, "", cleanUrl);
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname, location.search, location.hash]);

  return null;
};

const AppShell = () => {
  return (
    <div className="relative min-h-screen overflow-x-hidden app-surface" data-testid="app-shell">
      <div className="noise-overlay" />
      <Navbar />

      <main className="relative z-10 pt-36 pb-28 md:pt-24 md:pb-16" data-testid="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin-inquiries" element={<AdminLeadsPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>

      <Footer />
      <WhatsAppFloat />
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
};

function App() {
  return (
    <div className="App" data-testid="app-container">
      <BrowserRouter>
        <ScrollToTop />
        <AppShell />
      </BrowserRouter>
    </div>
  );
}

export default App;
